// Unpublished Work © 2021-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function ErrorView(props) {
    const {translations} = props;

    const errorTypographyProps = {
        children: translations.ONLINK_ACCESS_LIMITED_MESSAGE,
        fontSize: '1rem',
        fontWeight: 600,
        paragraph: true
    };

    const errorTypographyTitleProps = {
        children: translations.ONLINK_ACCESS_LIMITED,
        fontSize: '1.25rem',
        fontWeight: 'bold',
        variant: 'h2'
    };

    const errorViewProps = {
        padding: '13.375rem 1.25rem'
    };

    return (
        <Stack
            {...errorViewProps}
            direction='column'
            spacing={4}
            textAlign='center'
        >
            <Typography {...errorTypographyTitleProps}/>
            <Typography {...errorTypographyProps}/>
        </Stack>
    );
}

ErrorView.propTypes = {
    translations: PropTypes.translations
};

export default ErrorView;
